
<template>
  <img :src="path" :alt="title || iso">
</template>

<script>
export default {
  props: {
    iso: { type: String, default: null },
    title: { type: String, default: null },
    squared: { type: Boolean, default: false }
  },
  computed: {
    path () {
      const size = this.squared ? '1x1' : '4x3'
      const code = this.iso.toLowerCase()
      return `/site/themes/jetfly/static/images/flags/${size}/${code}.svg`
    }
  }
}
</script>
